import InstructionsForStarting from '@app/AppLanding/InstructionsForStarting.vue'
import TTQrCode from '@app/AppLanding/TTQrCode.vue'

export default function install(Vue) {
  Vue.component(InstructionsForStarting.name, InstructionsForStarting)
  Vue.component(TTQrCode.name, TTQrCode)
}
